module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/InfluencerExample/4_0-c3b62322db1ecea730e41bf5abf2fd91.png";